import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';

// Reactive current auth user, for components deep in the tree that aren't
// threaded a `user` prop (e.g. FootageTab, which is rendered by ProjectView).
// Seeds from auth.currentUser so a component that mounts after auth settled
// gets the user on the first render, then tracks sign-in/out.
export default function useAuthUser() {
  const [user, setUser] = useState(() => auth.currentUser);
  useEffect(() => onAuthStateChanged(auth, setUser), []);
  return user;
}
